module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmsbnp8-a0e3feb212be30d98943bb5a0b4b0aea.jpg";